
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/tim-kinerja/pelaksanaan/pemantauan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/tim-kinerja/pelaksanaan/pemantauan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/tim-kinerja/pelaksanaan/pemantauan"])
      });
    }
  